import React, { useState, useEffect } from 'react'

export default function Lightbox({ images, initialIndex, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex)
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)

  useEffect(() => {
    // Disable body scroll when lightbox is open
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const handlePrev = (e) => {
    e.stopPropagation()
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1))
  }

  const handleNext = (e) => {
    e.stopPropagation()
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1))
  }

  // Swipe logic for mobile
  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      // Swipe left -> next image
      handleNext({ stopPropagation: () => {} })
    }
    if (touchStart - touchEnd < -50) {
      // Swipe right -> prev image
      handlePrev({ stopPropagation: () => {} })
    }
  }

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowLeft') handlePrev(e)
      if (e.key === 'ArrowRight') handleNext(e)
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [currentIndex])

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4"
      onClick={onClose}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute right-6 top-6 text-white hover:text-red-500 text-3xl transition-colors z-50 cursor-pointer"
        aria-label="Luk"
      >
        <i className="fa-solid fa-xmark" />
      </button>

      {/* Prev Button */}
      <button
        onClick={handlePrev}
        className="absolute left-4 text-white hover:text-red-500 text-4xl transition-colors z-50 p-2 cursor-pointer hidden md:block"
        aria-label="Forrige"
      >
        <i className="fa-solid fa-chevron-left" />
      </button>

      {/* Image Container */}
      <div
        className="relative max-w-5xl max-h-[85vh] flex flex-col items-center justify-center select-none"
        onClick={(e) => e.stopPropagation()}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <img
          src={images[currentIndex]}
          alt={`Billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain border-4 border-zinc-900 shadow-2xl"
        />
        {/* Caption */}
        <div className="text-zinc-400 text-xs font-semibold tracking-wider mt-4">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>

      {/* Next Button */}
      <button
        onClick={handleNext}
        className="absolute right-4 text-white hover:text-red-500 text-4xl transition-colors z-50 p-2 cursor-pointer hidden md:block"
        aria-label="Næste"
      >
        <i className="fa-solid fa-chevron-right" />
      </button>
    </div>
  )
}
